type LatestAppVersion = {
  /**
   * Sequantial number - newer = higher
   *  - Increased number will trigger update modal (see `enforceAfter` too)
   */
  version: number;

  /**
   * We should leave a bit time before we enforce new version,
   * if that version only add new features which are not critical.
   *  - Otherwise it might be annoying displaying modal very often
   *  - And user might refresh website manually (without seeing modal)
   */
  enforceAfter: string; // ISO date

  /**
   * After modal is triggered, there will be automatic countdown to refresh without
   * user action. To prevent stuck web clients on old versions.
   * This define countdown delay.
   */
  automaticReloadTimeout: number | false;
};

export const fetchAppUpdateInformation = (): Promise<LatestAppVersion> =>
  fetch('/updateCheck.json').then(response => response.json());
